import React from 'react';
import './PauseButton.css';
import { Pause } from 'lucide-react';
import { useAudio } from '../utils/AudioContext'; 
import { playUiPauseSound } from '../utils/sounds'; 

function PauseButton({ onPause, gameState }) {
    const { sfxMuted } = useAudio();
    const isVisible = gameState === 'playing' || gameState === 'countdown';

    const handleClick = () => {
        playUiPauseSound(sfxMuted);
        onPause();
    };

    return (
        <button 
            className={`pause-icon-button ${!isVisible ? 'fade-out' : ''}`}
            onClick={handleClick} 
            aria-label="Pause"
        >
            <Pause />
        </button>
    );
}

export default PauseButton;